// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 22 ? "0bdaa058" : chunkId) + "." + {"22":"84390591dd021cf6","374":"16bdf9e61f54fe7a","667":"ef9f26116f2f3332","789":"fe8c34b2122ef307","813":"7b5f3db20c175435","936":"87b6f9df59f6ec97"}[chunkId] + ".js";
};